import { IThreadsModel } from './model';

export default (self: IThreadsModel) => ({
  get sortedList() {
    return self.toArray.sort((a, b) => {
      if (!!b.pinned !== !!a.pinned) return (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0);

      const aTime = a.pinned ? a.pinned_at : a.created_at;
      const bTime = b.pinned ? b.pinned_at : b.created_at;

      if (!aTime && !bTime) return 0;
      if (!aTime) return 1;
      if (!bTime) return -1;

      return bTime - aTime;
    });
  }
});
